import { getCoachPremiumPage } from 'constants/pages';
import { convertUnitPriceToFormattedPrice } from 'utils/shared/money/convertUnitPriceToFormattedPrice';
import { useViewer } from 'hooks/useViewer';
import Button, { ButtonLink } from 'components/Button';
import classNames from 'styles/utils/classNames';
import { SubscriptionCardProps } from './props';

const SubscriptionCard: React.FC<SubscriptionCardProps> = ({
  standalone = true,
  className,
  showMore = false,
  onSubscribe,
  amount,
  coachId,
  coachName,
  currency,
}) => {
  return (
    <div
      className={classNames(
        'flex h-fit flex-col gap-4 p-ds-xl',
        standalone &&
          'border-color-border-input-lightmode-primary rounded-[24px] border shadow-[0_4px_16px_0_rgba(0,0,0,0.08)] dark:border-color-border-input-darkmode',
        className,
      )}
    >
      <div className="typography-product-heading-compact-desktop flex justify-between gap-2 text-color-brand-primary">
        <h4>Subscription</h4>
        {+amount > 0 && (
          <span>{convertUnitPriceToFormattedPrice(+amount || 0, currency).priceDisplay}/month</span>
        )}
      </div>
      <p className="text-color-text-lightmode-secondary dark:text-color-text-darkmode-secondary">
        {amount
          ? `Subscribe to Coach ${coachName}'s page and get access to all of their exclusive content`
          : 'This coach has not setup the subscripions yet'}
      </p>
      {+amount > 0 && (
        <div className="mt-2 flex flex-col gap-3">
          {showMore && (
            <ButtonLink href={getCoachPremiumPage(coachId)} variant="secondary" size="lg">
              Show More
            </ButtonLink>
          )}

          <Button variant="brand" size="lg" onClick={onSubscribe}>
            Subscribe
          </Button>
        </div>
      )}
    </div>
  );
};

export default SubscriptionCard;
